export default {
  KEYSTORE_FILE_CLICKED: 'KeystoreFileClicked',
  MNEMONIC_PHRASE_CLICKED: 'MnemonicPhraseClicked',
  KEYSTORE_VERIFICATION: 'KeystoreVerification',
  KEYSTORE_DOWNLOAD: 'KeystoreDownload',
  KEYSTORE_SUCCESS_ACCESS: 'KeystoreSuccessAccessWallet',
  KEYSTORE_BACK: 'KeystoreDownloadBackClicked',
  KEYSTORE_SUCCESS_CREATE: 'KeystoreSuccessCreateWallet',
  MNEMONIC_SUCCESS: 'MnemonicSuccess',
  MNEMONIC_SUCCESS_ACCESS: 'MnemonicSuccessAccessWallet',
  MNEMONIC_WROTE_DOWN: 'WroteDownClicked',
  MNEMONIC_BACK: 'MnemonicBackToStepOne',
  MNEMONIC_SUCCESS_CREATE: 'MnemonicSuccessCreateWallet',
  NAVIGATE_TO_ACCESS: 'NavigateToAccess',
  BUY_HARDWARE: 'BuyHardware',
  SOFTWARE_METHOD: 'SoftwareMethod',
  CLOSE_SOFTWARE: 'CloseSoftware'
};
